import styled from "styled-components"

export const Logo = styled.img `

    height: 55px;
    width: auto;
    margin-left: 55px;
    margin-top: 3px;

`